import AddressHistory from "../../../model/addressHistory/AddressHistory";

export const ADDRESS_HISTORY_FETCHED = "ADDRESS_HISTORY_FETCHED";
export type ADDRESS_HISTORY_FETCHED = { contactId: string, history: AddressHistory[] }

export const ADDRESS_HISTORY_UPDATED = "ADDRESS_HISTORY_UPDATED";
export type ADDRESS_HISTORY_UPDATED = { contactId: string, history: AddressHistory[] }